<template>
  <PageWrapper
    v-if="canView"
    :active-section="SECTION_PUBLICATIONS"
    :active-page="PAGE_PUBLICATION_CHAT_ROOM"
    :breadcrumbs="breadcrumbs"
    page-name="Chat Room"
  >
    <iRow align="between" gap="standard" width="fill">
      <iColumn width="hug">
        <iHeading>
          {{ `${publication.name} Chat Room` }}
        </iHeading>
      </iColumn>
      <iColumn width="hug">
        <iButton variant="tertiary" @click="navigateToVideoCall">
          <iIcon icon="video" />
          <iText>Join Video Call</iText>
        </iButton>
      </iColumn>
    </iRow>
    <Conversation2 ref="conversation" context="publication_chatroom" :entity-id="publicationId" />
  </PageWrapper>
  <iText v-else>
    You don't have access to view this page.
  </iText>
</template>

<script>
import PageWrapper from "@/components/PageWrapper";
import {
  PAGE_PUBLICATION_CHAT_ROOM,
  SECTION_PUBLICATIONS,
} from "@/constants/nav-constants";
import { useCreatorPublicationStore } from "%/stores/creator-publication-store";
import { mapActions, mapState } from "pinia";
import { useMessageStore } from "%/apps/conversations/stores/message-store";
import { useConversationStore } from "%/apps/conversations/stores/conversation-store";
import Conversation2 from "%/apps/conversations/components/conversation/Conversation.vue";
import { useCollaboratorStore } from "@/stores/collaborator-store";

export default {
  name: "PublicationChatRoom",
  components: {
    Conversation2,
    PageWrapper,
  },
  data() {
    return {
      PAGE_PUBLICATION_CHAT_ROOM,
      SECTION_PUBLICATIONS,
      previewData: null,
      loadingMentions: false,
      filteredMentions: [],
      availableMentions: [],
    };
  },
  computed: {
    ...mapState(useCreatorPublicationStore, [
      "publication",
      "publicationId",
      "orgId",
    ]),
    ...mapState(useMessageStore, [
      "messages",
    ]),
    ...mapState(useConversationStore, [
      "conversations",
    ]),
    ...mapState(useCollaboratorStore, [
      "canView",
    ]),
    conversationId() {
      const conversationStore = useConversationStore();
      return conversationStore.getConversationIdByContext("publication_chatroom", this.publicationId);
    },
    breadcrumbs() {
      return [
        { url: "/", label: "Home" },
        { url: `/publication/org/${this.orgId}`, label: "My Publications" },
        {
          url: `/publication/${this.publicationId}`,
          label: this.publication.name,
        },
      ];
    },
  },
  mounted() {
    if (!this.canView) {
      const baseUrl = window.location.origin;
      const redirectUrl = `${baseUrl}/publication/${this.publicationId}`;

      setTimeout(() => {
        window.location.href = redirectUrl;
      }, 2000);
    }
  },
  methods: {
    ...mapActions(useConversationStore, [
      "getConversationIdByContext",
    ]),
    navigateToVideoCall() {
      const conversationId = this.conversationId;
      if (conversationId) {
        window.location.href = `/community/group-video/${conversationId}`;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.page-wrapper {
  :deep(.primary-content) {
    overflow-y: scroll;
  }
}
</style>
